import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { AlertContext, BackdropContext } from "../../../contexts";
import { multiFileUpload, assestType } from "../../../utils/common";
import { AlertProps, allowed_file_size } from "../../../utils";
import { useStyles } from "./style";
import { ImageUpload } from "../../../assets/imageupload";
import { ImageCard } from "../../../components";

export const SingleImgUpload = (props) => {
  const { t } = (props)
  const alert = React.useContext(AlertContext);
  const backdrop = React.useContext(BackdropContext);
  const updateState = async (data) => {
    backdrop.setBackDrop({
      ...backdrop,
      open: true,
      message: "Loading",
    });
    try {
      let propsData = {
        companyId: props?.companyId,
        type: assestType?.General_Images,
      };
      const uploaded_files = await multiFileUpload(data, propsData, alert, allowed_file_size);
      uploaded_files?.length > 0 && props?.selectedImageURL?.push(...uploaded_files);
      props?.updateImageURL(props?.selectedImageURL?.map((val) => val));
      backdrop.setBackDrop({
        ...backdrop,
        open: false,
        message: "",
      });
    } catch (err) {
      backdrop.setBackDrop({
        ...backdrop,
        open: false,
        message: "",
      });
      alert.setSnack({
        ...alert,
        open: true,
        severity: AlertProps.severity.error,
        msg: t("Not Edited!"),
        vertical: AlertProps.vertical.top,
        horizontal: AlertProps.horizontal.center,
      });
    }
  };

  const deleteImg = (e) => {
    props?.handleFile(e);
  };

  const classes = useStyles();
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={1.8}>
          <label className="btn label">
            <div className={classes.fileroot}>
              <input
                accept={props?.accept}
                type="file"
                name="myImage"
                style={{ display: "none" }}
                onChange={(e) => {
                  updateState(e.target.files);
                }}
                multiple
              />
              <center>
                <ImageUpload t={t} />
                <Typography className={classes.uploadTittle}>
                  {t("Upload image here")}
                </Typography>
              </center>
            </div>
          </label>
        </Grid>
        <Grid item xs={10.2} style={{ display: "flex" }} className={classes.imagleBox}>
          {props?.selectedImageURL?.map((val, index) => {
            return (
              <>
                <Box className={classes.imgContainer}>

                  <ImageCard
                    image={val?.url ?? ""}
                    onClick={() => deleteImg(val)}
                    imageName={val?.name ?? ""}
                    storage={val?.size ?? ""}
                    type={val?.type ?? ""}
                  />
                </Box>
              </>
            );
          })}
        </Grid>
      </Grid>
    </div>
  );
};
